module.exports = __webpack_public_path__ + "static/HomePage_Parallax-2498f792bf6bfb971fea97d5d7fcfc62.jpg";